import { jsxs as a, jsx as s } from "react/jsx-runtime";
import { forwardRef as B, useState as o } from "react";
import { H as F, B as T } from "../typography/Typography-CXNJ1SFo.mjs";
import "../icons/HeartToggle-Bwgo4FxH.mjs";
import { S as b, a as d, b as x, c as O } from "../icons/Icons-2z4jxD15.mjs";
const H = "_rds-alert--icon_m8jce_67", R = "_rds-alert--content-title_m8jce_79", D = "_rds-alert--content_m8jce_79", E = "_rds-alert--dismiss_m8jce_109", M = "_dismissed_m8jce_138", V = "_dismiss-fade-out_m8jce_1", e = {
  rdsAlertIcon: H,
  rdsAlertContentTitle: R,
  rdsAlertContent: D,
  rdsAlertDismiss: E,
  dismissed: M,
  dismissFadeOut: V
}, q = {
  warning: { title: "Advarsel", Icon: x },
  error: { title: "Feil", Icon: d },
  info: { title: "Informasjon", Icon: d },
  success: { title: "Vellykket", Icon: b }
}, z = B(
  ({
    className: c,
    intent: r = "warning",
    variant: i = "filled",
    testId: m = "rds-alert",
    heading: A,
    children: f,
    dismissible: _ = !0,
    lightBackground: v,
    onDismissed: t,
    LinkToDetails: u,
    ...C
  }, j) => {
    const [p, l] = o(!1), [I, n] = o(!1), g = ["rds-alert", v ? "rds-light" : "", p ? e.dismissed : "", c].filter(Boolean).join(" ");
    if (I)
      return null;
    const h = () => {
      l(!1), n(!1);
    }, { title: N, Icon: S } = q[r], k = (y) => {
      y.animationName === e.dismissFadeOut && (n(!0), t == null || t(h));
    }, w = _ && i !== "inline";
    return /* @__PURE__ */ a(
      "div",
      {
        role: "alert",
        "aria-live": "polite",
        ref: j,
        className: g,
        "data-testid": m,
        "data-intent": r,
        "data-variant": i,
        onAnimationEnd: k,
        ...C,
        children: [
          /* @__PURE__ */ s(S, { className: e.rdsAlertIcon }),
          /* @__PURE__ */ a("div", { className: e.rdsAlertContent, children: [
            /* @__PURE__ */ s(F, { className: e.rdsAlertContentTitle, as: "span", children: A || N }),
            /* @__PURE__ */ s(T, { as: "div", children: f }),
            u
          ] }),
          w && /* @__PURE__ */ s("div", { className: e.rdsAlertDismiss, children: /* @__PURE__ */ s("button", { "aria-label": "Avvis varsel", onClick: () => l(!0), children: /* @__PURE__ */ s(O, {}) }) })
        ]
      }
    );
  }
);
z.displayName = "Alert";
export {
  z as A
};
